import type {
  AppointmentPlanningManualFlexSlotOptionsPayload,
  AppointmentPlanningPreviewPayload,
} from "../../../../../../api/kehrblatt/planning"
import type { PlanningPreviewRow } from "../_shared/_logic/table-contract"

const normalizeText = (value: unknown): string => String(value ?? "").trim()

export const manualFlexSlotQueryKey = ({
  rowId,
  date,
  employeeId,
  durationMinutes,
}: {
  rowId: string
  date: string
  employeeId: string
  durationMinutes: string
}): string => `${rowId}:${date}:${employeeId}:${durationMinutes}`

export const buildManualFlexSlotOptionsPayload = ({
  organizationId,
  planningRequest,
  row,
}: {
  organizationId: string
  planningRequest: AppointmentPlanningPreviewPayload | null
  row: PlanningPreviewRow
}): { payload: AppointmentPlanningManualFlexSlotOptionsPayload; queryKey: string } | null => {
  const targetDate = normalizeText(row.manualFlexDate)
  const targetEmployeeId = normalizeText(row.appointmentEmployeeId)

  if (
    !organizationId ||
    !planningRequest ||
    row.planningStrategy !== "MANUAL" ||
    row.appointmentTypeValue !== "FLEX" ||
    !targetDate ||
    !targetEmployeeId
  ) {
    return null
  }

  return {
    payload: {
      organization_id: organizationId,
      planning_request: planningRequest,
      target_client_row_id: row.id,
      target_date: targetDate,
      target_employee_id: targetEmployeeId,
    },
    queryKey: manualFlexSlotQueryKey({
      rowId: row.id,
      date: targetDate,
      employeeId: targetEmployeeId,
      durationMinutes: normalizeText(row.estimatedDurationValue),
    }),
  }
}
